module.exports = __webpack_public_path__ + "components/flag/static/square/cv-4f3f6cc465b80117b74c3e4db8bd7bff.svg";